import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as channels from "./channels.actions";
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {ReportChannelAffinityService} from "../../services/report-channel-affinity.service";
import {Channel} from "../../interfaces/channel";
import {Site} from '../../interfaces/site';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {TypedAction} from '@ngrx/store/src/models';
import {Store} from '@ngrx/store';
import {PublicReportsService} from '../../services/public-reports.service';

@Injectable()
export class ChannelsEffects {
  private readonly _dataSet$: Observable<Serializer<Site>> = this._store.select(selectSite);

  private readonly _load$ = createEffect(() => this._actions$
    .pipe(
      ofType(channels.loadChannels),
      withLatestFrom(this._dataSet$),
      switchMap(([_, dataSet]: [TypedAction<string>, Serializer<Site>]) => this._reportChannelAffinityService.getChannels(dataSet)
        .pipe(
          map((results: SerializerResponse<Serializers<Channel>>) => channels.loadChannelSuccess({
            channels: results.data
          }))
        )
      )
    )
  );

  private readonly _loadPublic$ = createEffect(() => this._actions$.pipe(
    ofType(channels.loadPublicChannels),
    switchMap((action: TypedAction<string> & { uuid: string, token: string }) => this._publicReportsService.getChannels(action.uuid, action.token)
      .pipe(
        map((results: SerializerResponse<Serializers<Channel>>) => channels.loadChannelSuccess({
          channels: results.data
        }))
      )
    )
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _actions$: Actions,
    private readonly _reportChannelAffinityService: ReportChannelAffinityService,
    private readonly _publicReportsService: PublicReportsService
  ) {}
}
